export default __webpack_public_path__ + "static/media/Ies_Acuity.1d00877a.png";